import { ApartmentOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/thirdParty',
    name: 'thirdParty',
    redirect: '/thirdParty/device',
    meta: {
      title: '第三方设备',
      sort: 8,
      icon: ApartmentOutlined,
      isFullScreen: false,
      keepAlive: false,
      hidden: false,
      prem: true,
    },
    children: [
      {
        path: '/thirdParty/device',
        name: 'thirdPartyDevice',
        component: () => import('@/views/device/thirdParty/index.vue'),
        meta: {
          title: '设备台账',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/thirdParty/alarm',
        name: 'thirdPartyAlarm',
        component: () => import('@/views/device/thirdParty/alarm/index.vue'),
        meta: {
          title: '报警记录',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
